import { toggle } from '@/features/sidebar';
import { IconButton } from '@/layouts/authenticated/components/top-navigation/components/icon-button';

const SIDEBAR_ID = 'help-dropdown';

export function HelpButton() {
  const handleClick = () => {
    toggle(SIDEBAR_ID);
  };

  return <IconButton onClick={handleClick} icon="help" size="md" label="Need help?" showLabel={true} />;
}
